import store from 'store'

const el = '[data-content=TilmeldHoldKvittering]'

export default function(Store) {
    const DOM = document.querySelectorAll(el)
    if (DOM.length) {
        DOM.forEach((TilmeldHoldKvitteringDOM) => {
            const loginUrl = TilmeldHoldKvitteringDOM.dataset.loginurl
            const createProfileUrl = TilmeldHoldKvitteringDOM.dataset.createprofileurl
            const hasProfile = TilmeldHoldKvitteringDOM.dataset.hasprofile === "True"
            store.commit('main/set_page_overlay_content_data', { loginUrl, createProfileUrl, hasProfile })
        })
    }
}